import script from "./PopperActionPhone.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopperActionPhone.vue?vue&type=script&setup=true&lang=ts"

import "./PopperActionPhone.vue?vue&type=style&index=0&id=50ee5e5f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50ee5e5f"]])

export default __exports__